import { Component } from '@angular/core';

@Component({
  selector: 'app-myospri-tile',
  templateUrl: './myospri-tile.component.html',
  styleUrls: ['./myospri-tile.component.scss'],
})
export class MyOspriTileComponent{}
